import React from "react";
import { Container } from "reactstrap";

const ChallengesStrip = ({ data }) => {
    if (!data) return null;

    const { title, items, styles } = data;

    return (
        <section
            className="cbar"
            style={{
                background: styles?.background,
                color: styles?.textColor,
            }}
        >
            <Container>
                <div className="cbar-inner d-flex flex-wrap align-items-center justify-content-center gap-1">

                    {/* Title */}
                    <div className="cbar-lead fw-bold fs-5 text-center text-lg-start">
                        {title}
                    </div>

                    {/* Items */}
                    <div className="cbar-items d-flex flex-wrap justify-content-start gap-4">
                        {items.map((item, index) => (
                            <div
                                key={index}
                                className="cbar-item d-flex align-items-center gap-2 challenge-item"
                            >
                                <span>{item.icon}</span>
                                <span>{item.text}</span>
                            </div>
                        ))}
                    </div>

                </div>
            </Container>
        </section>
    );
};

export default ChallengesStrip;